/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import Configuration from "./base/configuration";
import ConfigureLimit from "./base/configure-limit";
import ConfigureSort from "./base/configure-sort";
import ConfigureRowTotals from "./base/configure-row-totals";
import ConfigureHideLegend from "./base/configure-hide-legend";

const PieChartConfiguration = (props) => {
  return (
    <Configuration title="Configure pie chart">
      <ConfigureLimit />
      <ConfigureSort />
      <ConfigureRowTotals />
      <ConfigureHideLegend />
    </Configuration>
  );
};

export default PieChartConfiguration;
